import { useCallback } from 'react';
import { useSafeState } from '..';

var stateChanger = function stateChanger(state) {
  return !state;
};
/**
 * Return callback function that re-renders component.
 */


export function useRerender() {
  var _a = useSafeState(false),
      setState = _a[1];

  return useCallback(function () {
    setState(stateChanger); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}